'use client';

import { useState, useEffect } from 'react';

/**
 * Animated counter that eases from 0 to `target` over `duration` ms.
 * Only runs when `run` is true. Returns the formatted current value.
 */
export function useCounter(
  target: number,
  duration = 1400,
  run = true,
  decimals = 0
): string | number {
  const [v, setV] = useState(0);

  useEffect(() => {
    if (!run) return;
    const s = performance.now();
    let raf: number;
    const tick = (n: number) => {
      const t = Math.min((n - s) / duration, 1);
      const e = 1 - Math.pow(1 - t, 3);
      setV(target * e);
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [run, target, duration]);

  return decimals ? v.toFixed(decimals) : Math.round(v);
}
